import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { BannerWithIconContainer } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/modalBanner.styles';

const EmployeeViewPendingManagerApprovalBanner = () => (
  <BannerWithIconContainer themeColor={ThemeColorType.iconGray} alignItems="center">
    <Text14 themeColor={ThemeColorType.white} semiBold>
      {gettext('Pending manager’s approval.')}
    </Text14>
  </BannerWithIconContainer>
);

export default EmployeeViewPendingManagerApprovalBanner;
